import { CalendarEventKey } from 'mini-calendar-event-types';
import deleteCalendarEventsByInstanceKeysFromCache from './deleteCalendarEventsByInstanceKeysFromCache';
import { eventEmitter, eventsRemoved } from 'mini-cal-event-emitters';

/**
 * Remove calendar events from events cache and emit eventsRemoved signal
 * @param folderId Calendar folder id
 * @param instanceKeys instance keys of the calendar events to be removed
 */
export default function deleteCalendarEventsByInstanceKeysAndNotify(
    instanceKeys: string[]
): CalendarEventKey[] {
    const calEventKeys = deleteCalendarEventsByInstanceKeysFromCache(instanceKeys);
    // Emit a signal that calendar events got deleted from the cache
    eventEmitter.emit(eventsRemoved, calEventKeys);
    return calEventKeys;
}
